import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'injuries'

export default function InjuriesPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue = value ? value : undefined

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const sex = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Do you have any recurring issues that affect your runs?',
      answer_key: sex.toLowerCase(),
      answer: sex,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.injuries.heading')}
      buttons={[
        {
          text: t('pages.onboarding.injuries.options.noInjuries'),
          value: 'noInjuries',
        },
        {
          text: t('pages.onboarding.injuries.options.minorAches'),
          value: 'minorAches',
        },
        {
          text: t('pages.onboarding.injuries.options.chronicCondition'),
          value: 'chronicCondition',
        },
        {
          text: t('pages.onboarding.injuries.options.currentlyRehabbing'),
          value: 'currentlyRehabbing',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
